/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import ProductBuyWithSnipcartButton from './ProductBuyWithSnipcartButton';
import ProductRequestSampleWithSnipcartButton from './ProductRequestSampleWithSnipcartButton';
import ProductShopExternalButton from './ProductShopExternalButton';

/** A shop button for either a Snipcart shop to order samples or purchase the products, or an external online shop.*/
export default function ProductShopButton({ product, ...rest }) {
  const snipcartEnabled = Boolean(process.env.GATSBY_SNIPCART_API_KEY);
  const shopMode = process.env.GATSBY_SHOP_MODE || 'samples';
  if (snipcartEnabled) {
    if (shopMode === 'samples') {
      return (
        <ProductRequestSampleWithSnipcartButton product={product} {...rest} />
      );
    }
    if (shopMode === 'shop') {
      return <ProductBuyWithSnipcartButton product={product} {...rest} />;
    }
  }
  return <ProductShopExternalButton product={product} {...rest} />;
}

export const fragment = graphql`
  fragment bb_ProductShopButton on Bottlebooks_Product {
    ...bb_ProductRequestSampleWithSnipcartButton
    ...bb_ProductBuyWithSnipcartButton
    ...bb_ProductShopExternalButton
  }
`;

ProductShopButton.fragment = gql`
  fragment ProductShopButton on Product {
    ...ProductRequestSampleWithSnipcartButton
    ...ProductBuyWithSnipcartButton
    ...ProductShopExternalButton
  }
  ${ProductRequestSampleWithSnipcartButton.fragment}
  ${ProductBuyWithSnipcartButton.fragment}
  ${ProductShopExternalButton.fragment}
`;
